import { render, staticRenderFns } from "./OrderInfo.vue?vue&type=template&id=c29f10cc"
import script from "./OrderInfo.vue?vue&type=script&lang=js"
export * from "./OrderInfo.vue?vue&type=script&lang=js"
import style0 from "./OrderInfo.vue?vue&type=style&index=0&id=c29f10cc&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports